const initialState = {
    organization: null,
    playlist: null,
    currentDashboard: null,
    dashboards: {}, // מפה של dashboardId -> dashboard
    loading: false,
    error: null
};

const publicScreenReducer = (state = initialState, action) => {
    switch (action.type) {
        // Load Public Screen
        case 'LOAD_PUBLIC_SCREEN_START':
            return {
                ...state,
                loading: true,
                error: null
            };

        case 'LOAD_PUBLIC_SCREEN_SUCCESS':
            return {
                ...state,
                organization: action.payload.organization,
                playlist: action.payload.playlist,
                currentDashboard: action.payload.dashboard,
                loading: false
            };

        case 'LOAD_PUBLIC_SCREEN_FAILURE':
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        // Load Dashboard
        case 'LOAD_DASHBOARD_START':
            return {
                ...state,
                loading: true
            };

        case 'LOAD_DASHBOARD_SUCCESS':
            return {
                ...state,
                currentDashboard: action.payload,
                dashboards: {
                    ...state.dashboards,
                    [action.payload.dashboardId]: action.payload
                },
                loading: false
            };

        case 'LOAD_DASHBOARD_FAILURE':
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        // Load All Dashboards
        case 'LOAD_ALL_DASHBOARDS_START':
            return {
                ...state,
                loading: true
            };

        case 'LOAD_ALL_DASHBOARDS_SUCCESS':
            return {
                ...state,
                dashboards: action.payload,
                loading: false
            };

        case 'LOAD_ALL_DASHBOARDS_FAILURE':
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        // Playlist Listener
        case 'PLAYLIST_UPDATED':
            return {
                ...state,
                playlist: action.payload
            };

        case 'PLAYLIST_LISTENER_ERROR':
            return {
                ...state,
                error: action.payload
            };

        default:
            return state;
    }
};

export default publicScreenReducer;
